<template>
  <FormSection title="Request Applicant To Make Changes">
    <div class="request-changes">
      <div class="form-field">
        <label>Comment</label>
        <textarea class="form-control" :value="value" @input="$emit('input', $event.target.value)" rows="4" placeholder="Enter your comment here..." />
      </div>
      <button class="el-button el-button--secondary send-button" @click="$emit('request-changes')">
        <i class="fa fa-envelope"></i>
        Send Email
      </button>
    </div>
  </FormSection>
</template>

<script>
import FormSection from './FormSection.vue'

export default {
  name: 'RequestChangesSection',
  components: {
    FormSection,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.request-changes {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-control {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
}

.form-control:focus {
  outline: none;
  border-color: #426dff;
  box-shadow: 0 0 0 2px rgba(66, 109, 255, 0.2);
}

.send-button {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #426dff;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.send-button:hover {
  background: #3854cc;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(66, 109, 255, 0.3);
}

.send-button i {
  font-size: 14px;
}
</style>
